<script lang="ts" setup>
import DirectionColumnIfMobileContainer from '../../DirectionColumnIfMobileContainer.vue';
import ResearchDataCard from '../../ResearchData/ResearchDataCard.vue';
import Img1 from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/ResearchDataCard/6.jpeg/6.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  num: number;
}>();
</script>

<template>
  <ResearchDataCard :num="num" :class="$style.container">
    <template #title>
      <strong
        >マイナス金利政策解除を受け「購入希望時期を早めたい」方は31.6%。理由は「住宅ローン金利が上がる前に買いたい」が80.6%と最多に</strong
      >
    </template>
    <DirectionColumnIfMobileContainer>
      <PinchImageModal :src="Img1" alt="グラフ" />
      <div>
        <p>
          マイホーム所有の検討を始めていると回答した方へ
          <strong
            >「2024年3月にマイナス金利政策解除が発表されたことにより、購入希望時期に変化はありましたか」</strong
          >
          と質問したところ
          <strong>「購入希望時期を早めたい」方が31.6％</strong>となりました。
        </p>
        <p>
          <strong
            >理由は「住宅ローン金利が上がる前に買いたい」が80.6%と最多</strong
          >となり、マイホーム購入希望者の3人に1人は、マイナス金利政策解除後の金利の変化へ敏感に反応していることが伺えます。
        </p>
      </div>
    </DirectionColumnIfMobileContainer>
  </ResearchDataCard>
</template>

<style lang="scss" module>
.container {
  :nth-child(n + 2) {
    margin-top: 8px;
  }
}
</style>
